import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 18,
    type: CHECKLIST_ITEM_TYPE.RECORD_FAILED_TO_ATTEND,
    manifestKey: 'RECORD_FAILED_TO_ATTEND',

    try_it: {
        button_label: 'Record Failed to Attend',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'RecordFailedToAttendCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { appointment_id: 'demo-appt-001' },
        },
    },
    pre_flight_diff: [
        'FTA confirmation triggers via separate appointment endpoint',
        'Lead status: CONSULTATION_BOOKED → FAILED_TO_ATTEND_CONSULTATION',
        'Checklist item: PENDING → YES',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        'Role gate: ADMIN or TCO only — USER role returns 403',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
